updateLastDiff